module.exports = {"532502001":"乐白道街道","532502002":"灵泉街道","532502101":"中和营镇","532502102":"小龙潭镇","532502201":"大庄回族乡","532502202":"羊街乡","532502203":"碑格乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532502.json
// module id = 2625
// module chunks = 0